import { Box, IconButton, Tooltip } from "@mui/material";
import { memo } from "react";
import { Clear, Search } from "@mui/icons-material";
import InfoIcon from "@mui/icons-material/Info";
import { StyledTextField } from "../styled/TextField";

interface StudentSearchProps {
  value: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSearchClick: () => void;
  handleClear: () => void;
}

const StudentSearch: React.FC<StudentSearchProps> = memo(
  ({ value, handleChange, handleSearchClick, handleClear }) => {
    // console.log("Search bar", value);

    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <StyledTextField
          variant='outlined'
          value={value}
          onChange={handleChange}
          placeholder='Type here…'
          sx={{
            width: "100%",
            backgroundColor: "white",
            borderRadius: "50px",
            "& fieldset": {
              borderRadius: "50px",
            },
          }}
          autoFocus
          size='small'
          onKeyDown={(ev) => {
            if (ev.key === "Enter") {
              ev.preventDefault();
              handleSearchClick();
            }
          }}
          InputProps={{
            startAdornment: (
              <IconButton
                aria-label='Search'
                size='small'
                onClick={handleSearchClick}
              >
                <Search fontSize='small' />
              </IconButton>
            ),
            endAdornment: (
              <IconButton
                title='Clear'
                aria-label='Clear'
                size='small'
                style={{ visibility: value ? "visible" : "hidden" }}
                onClick={handleClear}
              >
                <Clear fontSize='small' />
              </IconButton>
            ),
          }}
        />
        <Tooltip
          title='Search by username or by garmin id'
          placement='top-start'
        >
          <IconButton>
            <InfoIcon />
          </IconButton>
        </Tooltip>
      </Box>
    );
  }
);

export default StudentSearch;
